import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyModule, registerLazyOrchestrator } from 'owa-bundling';
import { manualSyncFoldersSortChange } from 'owa-folders';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "ManualSyncMail" */ './lazyIndex'),
    { name: 'ManualSyncMail' }
);

export const lazyManualSyncMail: LazyAction<typeof lazyIndex.manualSyncMail, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.manualSyncMail);

registerLazyOrchestrator(
    manualSyncFoldersSortChange,
    lazyModule,
    m => m.manualSyncFoldersSortChangeOrchestrator
);
